<div class="popup">
  <h4 mat-dialog-title>Detalles del Pedido</h4>
  <mat-card class="mat-elevation-z0">
    <table mat-table [dataSource]="Data.items" class="tabla">

      <!-- item Column -->
      <ng-container matColumnDef="articulo">
        <th mat-header-cell *matHeaderCellDef> ARTÍCULO </th>
        <td mat-cell *matCellDef="let item">{{item.dsName}}</td>
      </ng-container>

      <!-- cantidad Column  -->
      <ng-container matColumnDef="cantidad">
        <th mat-header-cell *matHeaderCellDef>CANTIDAD</th>
        <td mat-cell *matCellDef="let item"> {{item.nmQuantity}}</td>
      </ng-container>

      <!-- precio Column  -->
      <ng-container matColumnDef="precio">
        <th mat-header-cell *matHeaderCellDef>PRECIO </th>
        <td mat-cell *matCellDef="let item"> {{item.qtPrice |currency}}</td>
      </ng-container>

      <ng-container matColumnDef="extras">
        <th mat-header-cell *matHeaderCellDef>Extras </th>
        <td mat-cell *matCellDef="let item">
          <ul>
            <li *ngFor="let addon of item.addons">
              {{addon.dsName}} {{addon.nmQty}} x ({{addon.qtPrice | currency}})
            </li>
          </ul>
        </td>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>


    </table>

    <br />
    <table>
      <ng-container>
        <td><h5 mat-dialog-title mat-cell>Cargo de envio: {{Data.delivery | currency}}</h5></td>
        <td><h5 mat-dialog-title mat-cell>Desc. general: {{Data.discount | currency}}</h5></td>
        <td><h5 mat-dialog-title mat-cell>Sub-Total: {{Total + Delivery - Discount | currency}}</h5></td>
        <td><h5 mat-dialog-title mat-cell>Desc. en Prod.: {{Data.discountItemValue | currency}}</h5></td>
      </ng-container>
    </table>

    <br />
    <mat-dialog-content *ngIf="Data.notes" class="notas">Notas: {{Data.notes}}</mat-dialog-content>

  </mat-card>

  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-button mat-dialog-close class="btnCerrar">Cerrar</button>
  </div>
</div>
